import { Badge, Button, Card, Col, Container, Modal, Row } from "react-bootstrap";
import useMyProperties from "../../../Hooks/UseMyProperties/UseMyPropertiesHook";
import timeService, { DATE_FORMAT } from "../../../services/time/timeService";
import { useMemo, useState } from "react";
import QuickForm from "../../../Components/Forms/QuickForm/QuickForm";
import canAccess from "../../../services/accessService/accessService";
import AccessClickButton from "../../../Components/Buttons/AccessClickButton";
import { PropertyBookingEntry } from "../../../Types/bookingTypes";
import { BookingGuestEntryType } from "../../../Types/bookingGuestTypes";
import { FieldGeneratorFieldType } from "../../../Components/FormFields/FieldGenerator/FieldGenerator";
import { ConfirmModal } from "../../../Components/Modals/confirmModal";
import { useEditBookingGuestMutation, useGetBookingGuestsQuery, useGetBookingsQuery, useGetTurnoversQuery, useSendBookingGuestEmailMutation, useSendRegistrationReminderEmailMutation } from "../../../services/bClientApi";
import { FRONTEND_URL } from "../../../Config/config";
import AccessLinkButton from "../../../Components/Buttons/AccessLinkButton";
import { showSuccess } from "../../../redux/counter/counterSlice";
import { useAppDispatch } from "../../../redux/store";
import { BookingSourceIcon } from "../../../Components/Bookings/BookingEntry/BookingEntry";
import { getParentProperties } from "../../../Helpers/Property/multiUnit";
import CopyPhone from "../../../Components/Phone/CopyPhone";
import { TurnoverType } from "../../../Types/turnoverTypes";

export default function BookingGuestConfirmationPage() {

    const dispatch = useAppDispatch()

    const [editBookingGuest] = useEditBookingGuestMutation()

    const [sendBookingGuestEmail, { isLoading: sendBookingGuestEmailLoading, }] = useSendBookingGuestEmailMutation()

    const [sendRegistrationReminderEmail, { isLoading: sendRegistrationReminderEmailLoading, }] = useSendRegistrationReminderEmailMutation()

    const todayString = timeService.getCurrentTime().toFormat(DATE_FORMAT)

    const [propertyFilter, setPropertyFilter] = useState<string>('')

    const [mode, setMode] = useState<'all' | 'needsInfo' | 'pendingSend' | 'pendingConfirm' | 'confirmed'>('all')

    const [activeConfirmationModal, setActiveConfirmationModal] = useState({
        active: false,
        title: '',
        message: '',
        onConfirm: () => { },
        onClose: () => { }
    })

    const resetConfirmationModal = () => {
        setActiveConfirmationModal({
            active: false,
            title: '',
            message: '',
            onConfirm: () => { },
            onClose: () => { }
        })
    }

    const [idModalSettings, setIdModalSettings] = useState<{
        show: boolean;
        guestName?: string;
        images?: string[];
    }>({
        show: false,
    })

    const clearIdModal = () => {
        setIdModalSettings({
            show: false,
        })
    }

    const showIdModal = (guestName: string, images: string[]) => {
        setIdModalSettings({
            show: true,
            guestName,
            images,
        })
    }

    const { myProperties, publicPropertyIdKeys } = useMyProperties({
        accessRules: { hideBookingGuest: true }
    })

    // START BOOKING QUERY STUFF
    const startOfToday = timeService.getCurrentTime().startOf('day').toMillis()
    const queryEndDate = timeService.getCurrentTime().plus({ weeks: 2 }).startOf('day').toMillis()
    const [
        activeBookingQuery,
        setActiveBookingQuery
    ] = useState<any>({
        query: {
            checkIn: startOfToday,
            checkOut: queryEndDate,
            bookingStatus: ['new', 'pending', 'confirmed'],
            excludeSource: ['repairs', 'blocked'],
            requiresBookingGuestInfo: true,
            // bookingGuestInfoId: ['', null],
        },
        limit: 500,
        page: 1
    })

    const {
        data: bookingData,
        isLoading: bookingsLoading,
        // error,
        // requestId
    } = useGetBookingsQuery({
        bookingsQuery: {
            ...activeBookingQuery.query,
            propertyId: activeBookingQuery.query.propertyId ? activeBookingQuery.query.propertyId : publicPropertyIdKeys
        },
        pagination: {
            limit: activeBookingQuery.limit,
            page: activeBookingQuery.page
        }
    }, { skip: !activeBookingQuery.query.checkIn || publicPropertyIdKeys.length === 0 })
    // END BOOKING QUERY STUFF

    // START BOOKING GUEST INFO QUERY STUFF
    const [
        activeBookingGuestInfoQuery,
        setActiveBookingGuestInfoQuery
    ] = useState<any>({
        query: {
            // status: ['new', 'pending'],
            // status: 'confirmed',
            status: ['new', 'pending', 'confirmed'],
            arrivalTimeStart: startOfToday,
        },
        limit: 500,
        page: 1
    })

    // turnover info
    const endOfToday = timeService.getCurrentTime().endOf('day').toMillis()
    const { 
        data: turnoversData, 
        // isLoading: turnoversLoading
    } = useGetTurnoversQuery({
        turnoversQuery: {
            propertyId: activeBookingQuery.query.propertyId ? activeBookingQuery.query.propertyId : publicPropertyIdKeys,
            type: 'checkOut',
            status: ['new', 'pending', 'started', 'completed'],
            scheduledForEnd: endOfToday,
        },
        pagination: { page: 1, limit: 500 },
    }, { skip: publicPropertyIdKeys.length === 0 })

    const turnoverList = turnoversData?.docs || []
    const notReadyProperties: {
        [propertyId: string]: boolean
    } = {}
    turnoverList.forEach((turnover: TurnoverType) => {
        if (turnover.propertyId) {
            if (!notReadyProperties[turnover.propertyId]) {
                notReadyProperties[turnover.propertyId] = true
            }
        }
    })
    console.log(turnoverList)

    let propertyIdList: string[] = []
    if (activeBookingQuery.query.propertyId) {
        propertyIdList = [activeBookingQuery.query.propertyId]
        // check if propertyId has parents push those propertyIds too
        const parentProperties = getParentProperties(myProperties, activeBookingQuery.query.propertyId)
        parentProperties.forEach((parentProperty: any) => {
            propertyIdList.push(parentProperty.propertyId)
        })
    } else {
        propertyIdList = publicPropertyIdKeys
        const parentPropertyIds: {
            [propertyId: string]: boolean
        } = {}
        propertyIdList.forEach((propertyId: string) => {
            const parentProperties = getParentProperties(myProperties, propertyId)
            parentProperties.forEach((parentProperty: any) => {
                if (!parentPropertyIds[parentProperty.propertyId]) {
                    parentPropertyIds[parentProperty.propertyId] = true
                    propertyIdList.push(parentProperty.propertyId)
                }
            })
        })
    }

    const {
        data: bookingGuestsData,
        isLoading: bookingGuestsListLoading,

    } = useGetBookingGuestsQuery({
        bookingGuestsQuery: {
            ...activeBookingGuestInfoQuery.query,
            // propertyId: publicPropertyIdKeys,
            // propertyId: activeBookingQuery.query.propertyId ? activeBookingQuery.query.propertyId : publicPropertyIdKeys
            propertyId: propertyIdList
        },
        pagination: {
            limit: activeBookingGuestInfoQuery.limit,
            page: activeBookingGuestInfoQuery.page
        }
    }, { skip: !activeBookingGuestInfoQuery.query.arrivalTimeStart || publicPropertyIdKeys.length === 0 })


    // END BOOKING GUEST INFO QUERY STUFF

    const bookingGuestsByBookingId: any = {}
    const bookingGuestsById: any = {}
    if (bookingGuestsData?.docs?.length > 0) {
        bookingGuestsData.docs.forEach((bookingGuestInfo: any) => {
            if (bookingGuestInfo.bookingId) {
                bookingGuestsByBookingId[bookingGuestInfo.bookingId] = bookingGuestInfo
            }
            bookingGuestsById[bookingGuestInfo._id] = bookingGuestInfo
        })
    }

    const changeMode = (newMode: 'all' | 'needsInfo' | 'pendingSend' | 'pendingConfirm' | 'confirmed') => {
        if (newMode === mode) {
            return
        }
        setMode(newMode)
    }

    const updateActiveBookingQuery = (queryInfo: any) => {
        setActiveBookingQuery({
            ...activeBookingQuery,
            query: {
                ...activeBookingQuery.query,
                ...queryInfo
            }
        })
    }

    const updateActiveBookingGuestInfoQuery = (queryInfo: any) => {
        setActiveBookingGuestInfoQuery({
            ...activeBookingGuestInfoQuery,
            query: {
                ...activeBookingGuestInfoQuery.query,
                ...queryInfo
            }
        })
    }

    const handleFormSubmit = (values: any) => {

        const newBookingQuery: any = {}
        const newGuestInfoQuery: any = {}

        // handle checkIn and checkOut
        newBookingQuery.checkIn = timeService.dateToMillis(values.checkIn)
        newBookingQuery.checkOut = timeService.dateToMillis(values.checkOut)

        newGuestInfoQuery.arrivalTimeStart = timeService.dateToMillis(values.checkIn)

        newBookingQuery.firstName = values.firstName
        if (!values.firstName) {
            delete newBookingQuery.firstName
        }
        newBookingQuery.lastName = values.lastName
        if (!values.lastName) {
            delete newBookingQuery.lastName
        }

        newGuestInfoQuery.firstName = values.firstName
        if (!values.firstName) {
            delete newGuestInfoQuery.firstName
        }
        newGuestInfoQuery.lastName = values.lastName
        if (!values.lastName) {
            delete newGuestInfoQuery.lastName
        }

        updateActiveBookingQuery(newBookingQuery)
        updateActiveBookingGuestInfoQuery(newGuestInfoQuery)
    }

    const dataByDay = useMemo(() => {

        const bookingsList = bookingData?.docs || []
        const bookingGuestsList = bookingGuestsData?.docs || []

        const dataByDayList: any[] = []

        const dateRangeHash = timeService.createDateHashObject(
            activeBookingQuery.query.checkIn,
            activeBookingQuery.query.checkOut
        )

        // Helper function to check if property should be filtered out
        const shouldFilterProperty = (propertyId: string) => {
            if (!propertyFilter) return false

            if (myProperties[propertyId]) {
                const propertyJson = JSON.stringify(myProperties[propertyId]).toLowerCase()
                return propertyJson.indexOf(propertyFilter.toLowerCase()) === -1
            }
            return false
        }

        if (!bookingsLoading && bookingsList) {
            bookingsList.forEach((bookingInfo: PropertyBookingEntry) => {
                // Filter by property
                if (shouldFilterProperty(bookingInfo.propertyId)) {
                    return
                }

                const formattedCheckIn = timeService.getFormattedTime(bookingInfo.checkIn, DATE_FORMAT)
                if (!dateRangeHash[formattedCheckIn]) {
                    return
                }
                if (!dateRangeHash[formattedCheckIn].bookings) {
                    dateRangeHash[formattedCheckIn].bookings = []
                }
                dateRangeHash[formattedCheckIn].bookings.push(bookingInfo)
            })
        }

        if (!bookingGuestsListLoading && bookingGuestsList) {
            bookingGuestsList.forEach((bookingGuestInfo: BookingGuestEntryType) => {
                // Filter by property
                if (shouldFilterProperty(bookingGuestInfo.propertyId)) {
                    return
                }

                const formattedCheckIn = timeService.getFormattedTime(bookingGuestInfo.arrivalTime, DATE_FORMAT)
                // remove if property does not require bookingGuestInfo
                if (myProperties[bookingGuestInfo.propertyId] && !myProperties[bookingGuestInfo.propertyId].services?.bookingGuestInfo) {
                    return
                }
                if (!dateRangeHash[formattedCheckIn]) {
                    return
                }
                if (!dateRangeHash[formattedCheckIn].bookingGuests) {
                    dateRangeHash[formattedCheckIn].bookingGuests = []
                }
                dateRangeHash[formattedCheckIn].bookingGuests.push(bookingGuestInfo)
            })
        }

        Object.keys(dateRangeHash).forEach((dateKey: string) => {
            dataByDayList.push(dateRangeHash[dateKey])
        })

        return dataByDayList
    }, [bookingGuestsData, bookingGuestsListLoading, bookingData, bookingsLoading, activeBookingQuery.query.checkIn, activeBookingQuery.query.checkOut, myProperties, propertyFilter])

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Booking Guest Confirmation</h1>
                    <hr />

                    <QuickForm
                        // key={currentRequestId}
                        initialData={{
                            // name: activeQuery.query.name,
                            propertyFilter: '',
                            dateRange: null,
                            checkIn: activeBookingQuery.query.checkIn,
                            checkOut: activeBookingQuery.query.checkOut,
                        }}
                        fields={bookingGuestSearchFields}
                        disabled={bookingsLoading || bookingGuestsListLoading}
                        onChange={(data: any) => {
                            const fieldName = data.target.name
                            const fieldValue = data.target.value
                            if (fieldName === 'propertyFilter') {
                                setPropertyFilter(fieldValue || '')
                            }
                        }}
                        onSubmit={handleFormSubmit}
                    />

                    <hr />

                    <div>

                        {/* All button */}

                        <AccessClickButton
                            variant={mode === 'all' ? 'primary' : 'secondary'}
                            onClick={() => changeMode('all')}
                            className="mb-2 me-2"
                            text={"All"}
                            action={'all'}
                            resource={'bookingGuest'}
                        />


                        <AccessClickButton
                            variant={mode === 'needsInfo' ? 'primary' : 'secondary'}
                            onClick={() => changeMode('needsInfo')}
                            className="mb-2 me-2"
                            text={"Needs Info"}
                            action={'needsInfo'}
                            resource={'bookingGuest'}
                        />


                        <AccessClickButton
                            variant={mode === 'pendingSend' ? 'primary' : 'secondary'}
                            onClick={() => {
                                changeMode('pendingSend')
                            }}
                            className="mb-2 me-2"
                            text={"Pending Send"}
                            action={'pendingSend'}
                            resource={'bookingGuest'}
                        />

                        <AccessClickButton
                            variant={mode === 'pendingConfirm' ? 'primary' : 'secondary'}
                            onClick={() => {
                                changeMode('pendingConfirm')
                            }}
                            className="mb-2 me-2"
                            text={"Pending Confirm"}
                            action={'pendingConfirm'}
                            resource={'bookingGuest'}
                        />

                        <AccessClickButton
                            variant={mode === 'confirmed' ? 'primary' : 'secondary'}
                            onClick={() => {
                                changeMode('confirmed')
                            }}
                            className="mb-2 me-2"
                            text={"Confirmed"}
                            action={'confirmed'}
                            resource={'bookingGuest'}
                        />
                    </div>
                    <hr />


                    {!bookingsLoading && bookingData?.docs?.length > 0 && (
                        <div>
                            {dataByDay.map((dayData: any, idx: number) => {
                                if (!dayData.bookings) return null
                                return (
                                    <div className="" key={`booking-day-${idx}-${dayData.timeStamp}`}>
                                        <h3 style={stickyStyle}>
                                            <b>{dayData.date === todayString ? 'TODAY' : ''}</b> {timeService.getFormattedTime(dayData.timeStamp, 'LL/dd/yyyy cccc')}
                                        </h3>
                                        <hr />
                                        {dayData.bookings && dayData.bookings.map((bookingEntry: any, idx: number) => {

                                            const propertyId = bookingEntry?.propertyId
                                            if (propertyId && !myProperties[propertyId]) return null

                                            const extraButtons = []

                                            let bookingGuestEntry: any = {}
                                            let needsInfo = true

                                            let colorBg = '#ffe9ec' // red

                                            let isOwnerBooking = false

                                            if (bookingEntry?.source === 'owner') {
                                                // if (bookingEntry?.source === 'owner' || bookingEntry?.source === 'owner-guest') {
                                                isOwnerBooking = true
                                            }

                                            let awaitingConfirmationCode = false
                                            if (bookingEntry?.confirmationCode === 'submitted') {
                                                awaitingConfirmationCode = true
                                            }

                                            if (
                                                bookingGuestsByBookingId[bookingEntry._id] ||
                                                (bookingEntry.bookingGuestInfoId && bookingGuestsById[bookingEntry.bookingGuestInfoId])
                                            ) {
                                                bookingGuestEntry = bookingGuestsByBookingId[bookingEntry._id] ? bookingGuestsByBookingId[bookingEntry._id] : bookingGuestsById[bookingEntry.bookingGuestInfoId]
                                                needsInfo = false
                                                colorBg = '#faf8cf' // yellow

                                                if (bookingGuestEntry.status === 'pending') {
                                                    colorBg = '#fff' // white
                                                }

                                                if (bookingGuestEntry.status === 'confirmed' && !awaitingConfirmationCode) {
                                                    colorBg = '#e8fbe8' // green
                                                }

                                                if (bookingGuestEntry.status === 'new' && canAccess('bookingGuest', 'markPending')) {
                                                    extraButtons.push({
                                                        label: 'Mark Pending',
                                                        disabled: sendBookingGuestEmailLoading ? true : false,
                                                        variant: 'secondary',
                                                        onClick: async () => {
                                                            setActiveConfirmationModal({
                                                                active: true,
                                                                title: 'Mark Pending',
                                                                message: 'Are you sure you want to mark this guest as pending?',
                                                                onConfirm: async () => {
                                                                    const updatedBookingGuest = await editBookingGuest({
                                                                        bookingGuestId: bookingGuestEntry._id,
                                                                        bookingGuestInfo: {
                                                                            status: 'pending'
                                                                        }
                                                                    }).unwrap()
                                                                    console.log('updatedBookingGuest', updatedBookingGuest)
                                                                    dispatch(showSuccess('Guest marked as pending'))
                                                                },
                                                                onClose: resetConfirmationModal
                                                            })
                                                        }
                                                    })
                                                }

                                                // Add button to view all ID images
                                                const allIdImages: string[] = [];
                                                if (bookingGuestEntry?.main?.idImage) {
                                                    allIdImages.push(bookingGuestEntry.main.idImage);
                                                }
                                                if (bookingGuestEntry?.guests) {
                                                    bookingGuestEntry.guests.forEach((guest: any) => {
                                                        if (guest.idImage) {
                                                            allIdImages.push(guest.idImage);
                                                        }
                                                    });
                                                }

                                                if (allIdImages.length > 0) {
                                                    extraButtons.push({
                                                        label: `View 🪪 (${allIdImages.length})`,
                                                        disabled: false,
                                                        variant: 'secondary',
                                                        onClick: () => {
                                                            showIdModal(
                                                                `${bookingGuestEntry?.main?.firstName} ${bookingGuestEntry?.main?.lastName} - All IDs`,
                                                                allIdImages
                                                            );
                                                        }
                                                    })
                                                }

                                                if (canAccess('bookingGuest', 'sendConfirm')) {
                                                    extraButtons.push({
                                                        label: `${bookingGuestEntry.status !== 'new' ? 'Resend ' : 'Send '}✉️`,
                                                        // label: `${bookingGuestEntry.status !== 'new' ? 'Resend ' : ''}✉️ the 🦃`,
                                                        disabled: sendBookingGuestEmailLoading ? true : false,
                                                        variant: 'primary',
                                                        onClick: async () => {
                                                            setActiveConfirmationModal({
                                                                active: true,
                                                                title: `${bookingGuestEntry.status !== 'new' ? 'Resend' : 'Send'} Confirmation Email`,
                                                                message: `Are you sure you want to ${bookingGuestEntry.status !== 'new' ? 'resend' : 'send'} the confirmation email?`,
                                                                onConfirm: async () => {
                                                                    const mailInfo = await sendBookingGuestEmail(
                                                                        bookingGuestEntry._id
                                                                    ).unwrap()
                                                                    console.log('mailInfo', mailInfo)
                                                                    dispatch(showSuccess('Email sent'))
                                                                },
                                                                onClose: resetConfirmationModal
                                                            })
                                                        }
                                                    })
                                                }

                                                if (bookingGuestEntry.status === 'pending' && canAccess('bookingGuest', 'markConfirm')) {
                                                    extraButtons.push({
                                                        label: 'Confirm Guest',
                                                        disabled: sendBookingGuestEmailLoading ? true : false,
                                                        variant: 'success',
                                                        onClick: async () => {
                                                            setActiveConfirmationModal({
                                                                active: true,
                                                                title: 'Confirm Guest',
                                                                message: 'Are you sure you want to confirm this guest?',
                                                                onConfirm: async () => {
                                                                    const updatedBookingGuest = await editBookingGuest({
                                                                        bookingGuestId: bookingGuestEntry._id,
                                                                        bookingGuestInfo: {
                                                                            status: 'confirmed'
                                                                        }
                                                                    }).unwrap()
                                                                    console.log('updatedBookingGuest', updatedBookingGuest)
                                                                },
                                                                onClose: resetConfirmationModal
                                                            })
                                                        }
                                                    })
                                                }

                                                if (bookingGuestEntry.status === 'pending' && canAccess('bookingGuest', 'markDenied')) {
                                                    extraButtons.push({
                                                        label: 'Deny Guest',
                                                        disabled: sendBookingGuestEmailLoading ? true : false,
                                                        variant: 'danger',
                                                        onClick: async () => {
                                                            setActiveConfirmationModal({
                                                                active: true,
                                                                title: 'Deny Guest',
                                                                message: 'Are you sure you want to deny this guest?',
                                                                onConfirm: async () => {
                                                                    const updatedBookingGuest = await editBookingGuest({
                                                                        bookingGuestId: bookingGuestEntry._id,
                                                                        bookingGuestInfo: {
                                                                            status: 'new'
                                                                        }
                                                                    }).unwrap()
                                                                    console.log('updatedBookingGuest', updatedBookingGuest)
                                                                },
                                                                onClose: resetConfirmationModal
                                                            })
                                                        }
                                                    })
                                                }

                                            }
                                            let guestName = `${bookingEntry?.contactInfo?.firstName} ${bookingEntry?.contactInfo?.lastName}`
                                            const propertyName = myProperties[bookingEntry.propertyId]?.title
                                            const guestPhone = bookingEntry?.contactInfo?.phone

                                            const isPropertyReady = !notReadyProperties[bookingEntry.propertyId]

                                            const bookingDetailsLink = `${FRONTEND_URL}/booking-details/${bookingEntry._id}`

                                            const bookingEmailAddress = bookingEntry?.contactInfo?.email && bookingEntry.contactInfo.email.indexOf('airbnb.com') === -1 ? bookingEntry.contactInfo.email : null

                                            // Add registration reminder button when needsInfo is true
                                            if (needsInfo && bookingEmailAddress) {
                                                extraButtons.push({
                                                    label: 'Send Registration Reminder ✉️',
                                                    disabled: sendRegistrationReminderEmailLoading,
                                                    variant: 'warning',
                                                    onClick: async () => {
                                                        setActiveConfirmationModal({
                                                            active: true,
                                                            title: 'Send Registration Reminder Email',
                                                            message: 'Are you sure you want to send the registration reminder email?',
                                                            onConfirm: async () => {
                                                                try {
                                                                    const mailInfo = await sendRegistrationReminderEmail(bookingEntry._id).unwrap()
                                                                    console.log('mailInfo', mailInfo)
                                                                    dispatch(showSuccess('Registration Reminder Email Sent'))
                                                                } catch (error) {
                                                                    console.error('Error sending registration reminder email:', error)
                                                                }
                                                            },
                                                            onClose: resetConfirmationModal
                                                        })
                                                    }
                                                })
                                            }

                                            // This colors the card green if confirmation code exists solely for fontainebleau properties
                                            if (bookingEntry?.confirmationCode && bookingEntry.confirmationCode.length > 0 && bookingEntry.confirmationCode !== 'submitted') {
                                                // color it green
                                                colorBg = '#e8fbe8' // green
                                            }

                                            if (mode === 'needsInfo' && !needsInfo) {
                                                return null
                                            }

                                            if (mode === 'pendingSend' && bookingGuestEntry.status !== 'new') {
                                                return null
                                            }

                                            if (mode === 'pendingConfirm' && bookingGuestEntry.status !== 'pending') {
                                                return null
                                            }

                                            if (mode === 'confirmed' && bookingGuestEntry.status !== 'confirmed') {
                                                return null
                                            }

                                            return (
                                                <Card
                                                    key={`booking-entry-${idx}-${bookingEntry._id}`}
                                                    className="mb-3"
                                                    style={{
                                                        backgroundColor: colorBg,
                                                    }}
                                                >
                                                    <Card.Body>

                                                        {needsInfo && (
                                                            <>
                                                                <Card.Title>
                                                                    {guestName}
                                                                </Card.Title>
                                                                <Card.Subtitle className="mb-2">Check In: {timeService.getFormattedTime(bookingEntry.checkIn)}</Card.Subtitle>
                                                                <b>Property:</b> {propertyName} <br />
                                                                {bookingEntry?.contactInfo?.email && bookingEntry.contactInfo.email.indexOf('airbnb.com') === -1 && (<><b>Email:</b> {bookingEntry?.contactInfo?.email} <br /></>)}
                                                                {guestPhone && (<><b>Phone:</b> {guestPhone} <CopyPhone phoneNumber={guestPhone} /> <br /></>)}
                                                                {canAccess('booking', 'airbnbReservationDetails') && (
                                                                    <>
                                                                        <b>Source:</b> {bookingEntry?.source}<BookingSourceIcon bookingInfo={bookingEntry} />
                                                                        <br />
                                                                    </>
                                                                )}
                                                                {bookingEntry?.confirmationCode && (<><b>Confirmation Code:</b> {bookingEntry.confirmationCode} <br /></>)}
                                                                <a href={bookingDetailsLink} target="_blank" rel="noreferrer">Registration Link</a> <br />
                                                                {isOwnerBooking && (<span className="badge bg-warning text-dark me-2">Owner</span>)}
                                                                {!isPropertyReady ? (<span className="badge bg-danger">Not Ready</span>) : (<span className="badge bg-success">Ready</span>)}
                                                            </>
                                                        )}

                                                        {!needsInfo && (
                                                            <>
                                                                <Card.Title>
                                                                    {bookingGuestEntry?.main?.firstName} {bookingGuestEntry?.main?.lastName} {bookingGuestEntry?.main?.idImage && (
                                                                        <Button
                                                                            size="sm"
                                                                            variant="link"
                                                                            style={{
                                                                                fontSize: '0.7rem',
                                                                                padding: '0 0.5rem'
                                                                            }}
                                                                            onClick={() => showIdModal(
                                                                                `${bookingGuestEntry?.main?.firstName} ${bookingGuestEntry?.main?.lastName}`,
                                                                                [bookingGuestEntry?.main?.idImage]
                                                                            )}>
                                                                            View ID
                                                                        </Button>
                                                                    )}
                                                                </Card.Title>
                                                                <Card.Subtitle className="mb-2">Arrival: {timeService.getFormattedTime(bookingGuestEntry?.arrivalTime)}</Card.Subtitle>
                                                                <b>Property:</b> {propertyName} <br />
                                                                <b>Status:</b> {bookingGuestEntry?.status} <br />
                                                                {bookingGuestEntry?.main?.email && (<><b>Email:</b> {bookingGuestEntry?.main?.email} <br /></>)}
                                                                {bookingGuestEntry?.main?.phone && (<><b>Phone:</b> {bookingGuestEntry?.main?.phone} <CopyPhone phoneNumber={bookingGuestEntry?.main?.phone} /> <br /></>)}
                                                                {bookingGuestEntry?.main?.whatsAppNumber && (<><b>WhatsApp:</b> {bookingGuestEntry?.main?.whatsAppNumber} <br /></>)}
                                                                <b>Booker Name:</b> {guestName} <br />

                                                                {canAccess('booking', 'airbnbReservationDetails') && (
                                                                    <>
                                                                        <b>Source:</b> {bookingEntry?.source} <BookingSourceIcon bookingInfo={bookingEntry} />
                                                                        <br />
                                                                    </>
                                                                )}

                                                                {bookingEntry?.confirmationCode && (<><b>Confirmation Code:</b> {bookingEntry.confirmationCode} <br /></>)}

                                                                {isOwnerBooking && (<span className="badge bg-warning text-dark me-2">Owner</span>)}
                                                                {!isPropertyReady ? (<span className="badge bg-danger">Not Ready</span>) : (<span className="badge bg-success">Ready</span>)}

                                                                {bookingGuestEntry?.guests && bookingGuestEntry?.guests.length > 0 && (
                                                                    <>
                                                                        <hr />
                                                                        <b>Guests: </b>
                                                                        {bookingGuestEntry?.guests.map((guest: any, gIdx: number) => {
                                                                            if (guest.idImage) {
                                                                                return (
                                                                                    <Badge
                                                                                        key={`guest-${gIdx}`}
                                                                                        // href="#"
                                                                                        onClick={(e) => {
                                                                                            e.preventDefault();
                                                                                            showIdModal(
                                                                                                `${guest.firstName} ${guest.lastName}`,
                                                                                                [guest.idImage]
                                                                                            );
                                                                                        }}
                                                                                        className="me-1 mb-1"
                                                                                        bg={"dark"}
                                                                                        style={{ cursor: 'pointer' }}>
                                                                                        {guest.firstName} {guest.lastName}
                                                                                    </Badge>
                                                                                )
                                                                            }
                                                                            return (
                                                                                <span
                                                                                    key={`guest-${gIdx}`}
                                                                                    className="badge bg-dark me-1 mb-1">
                                                                                    {guest.firstName} {guest.lastName}
                                                                                </span>
                                                                            )
                                                                        })}
                                                                        <br />
                                                                    </>
                                                                )}
                                                            </>
                                                        )}

                                                    </Card.Body>

                                                    <Card.Footer>
                                                        <>
                                                            <AccessLinkButton
                                                                action={'booking'}
                                                                color={'secondary'}
                                                                size={'sm'}
                                                                text={'View Booking'}
                                                                to={`/booking/${bookingEntry._id}`}
                                                            />
                                                            {!needsInfo && (
                                                                <AccessLinkButton
                                                                    action={'booking-guest'}
                                                                    text={'View Guest'}
                                                                    size={'sm'}
                                                                    color="secondary"
                                                                    to={`/booking-guest/${bookingGuestEntry._id}`}
                                                                />
                                                            )}
                                                            {extraButtons && extraButtons.map((button, bIdx) => (
                                                                <Button
                                                                    key={`extra-button-${bIdx}`}
                                                                    className="me-1 mb-1"
                                                                    size={'sm'}
                                                                    variant={button.variant ? button.variant : 'secondary'}
                                                                    disabled={button.disabled}
                                                                    onClick={() => button.onClick()}>
                                                                    {button.label}
                                                                </Button>
                                                            ))}

                                                        </>

                                                    </Card.Footer>

                                                </Card>
                                            )
                                        })}
                                    </div>
                                )
                            })}
                        </div>
                    )}
                </Col>
            </Row>

            <ConfirmModal
                active={activeConfirmationModal.active}
                title={activeConfirmationModal.title}
                message={activeConfirmationModal.message}
                onConfirm={() => {
                    activeConfirmationModal.onConfirm()
                    resetConfirmationModal()
                }}
                onClose={() => {
                    activeConfirmationModal.onClose()
                    // resetConfirmationModal()
                }}
            />

            <Modal
                size={'lg'}
                show={idModalSettings.show}
                onHide={clearIdModal}>
                <Modal.Header closeButton>
                    <Modal.Title>ID Pictures - {idModalSettings.guestName}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {idModalSettings.images && idModalSettings.images.length > 0 && (
                        <div style={{
                            display: idModalSettings.images.length > 1 ? 'flex' : 'block',
                            flexWrap: 'wrap',
                            gap: '10px',
                            justifyContent: 'center'
                        }}>
                            {idModalSettings.images.map((imageUrl: string, idx: number) => (
                                <div key={`id-image-${idx}`}>
                                    <img
                                        src={imageUrl}
                                        alt={`ID ${idx + 1}`}
                                        style={{
                                            maxWidth: (idModalSettings.images && idModalSettings.images.length > 1) ? '150px' : '300px',
                                            width: '100%',
                                            height: 'auto',
                                            display: 'block',
                                            margin: (idModalSettings.images && idModalSettings.images.length === 1) ? '0 auto' : '0'
                                        }}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={clearIdModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

        </Container>
    )
}

const stickyStyle: any = {
    position: 'sticky',
    top: 0,
    backgroundColor: 'white',
    zIndex: 10,
    paddingTop: '10px',
    paddingBottom: '10px',
}

const bookingGuestSearchFields: FieldGeneratorFieldType[] = [
    {
        fieldName: 'propertyFilter',
        fieldLabel: 'Property Filter',
        fieldType: 'text',
        required: false,
    },
    {
        fieldName: 'dateRange',
        fieldLabel: 'Date Range',
        fieldType: 'dateRange',
        placeholder: 'mm/dd/yyyy - mm/dd/yyyy',
        extra: {
            startDate: 'checkIn',
            endDate: 'checkOut',
        },
    },
    {
        fieldName: 'checkIn',
        fieldLabel: 'Check In',
        fieldType: 'date',
        placeholder: 'Check In',
        required: true,
        hidden: true,
    },
    {
        fieldName: 'checkOut',
        fieldLabel: 'Check In',
        fieldType: 'date',
        placeholder: 'Check In',
        required: true,
        hidden: true,
    },
]